module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-9.8b9cc6c6.svg";